/** Primary route for domains, inboxes, warming, and outbound phone. */
export const OUTBOUND_SETUP_PATH = '/outbound-setup';
